import Hosts from '../../../Hosts';

const object_type = 'intranet/groups'
const object_type2 = 'intranet/groups/next'


const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`
const api_list_order = (companycode) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/order`

const base_endpoint = '/intranet_groups'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,    
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        name: '',       
        description: '',
        color: {
            primary: '',
            primary_rgb: '',
            secondary: '',
        },        
        type: 'theme',  
        foto: [],
        responsaveis: [],   
        submissoes: [],    
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order
}